import { defineSetting } from '../settingsRegistry';
import { setTruePxScene, truePxFigures } from './truepx/flags';

declare module '../settingsRegistry' {
  interface Settings {
    /**
     * Lane C0-TRUEPX-GAME (render/truepx/): true-pixel clean-up of figures and the whole scene (one shared palette of
     * material ramps, small clusters merged, cel light from the upper right, selective outline), made once where the
     * art is made. The scene changes at once; figures after a reload.
     */
    truePx: boolean;
  }
}

defineSetting({
  key: 'truePx',
  default: false,
  order: 103,
  menu: {
    group: 'visual',
    label: 'พิกเซลอาร์ตแท้ (ทดลอง)',
    note: () =>
      loaded && truePxFigures() !== loaded.truePx
        ? 'ฉากเปลี่ยนแล้ว ตัวละครจะเปลี่ยนหลังโหลดเกมใหม่'
        : 'ฉากและตัวละครใช้ชุดสีเดียวกัน เก็บจุดสีเล็ก ๆ แสงจากขวาบน เส้นขอบเป็นสีเข้มของวัตถุ',
    changed: (on) => {
      setTruePxScene(on);
      // The scenery is built again (renderer.ts listens); the ground repaints itself (terrain.ts `Ground`).
      window.dispatchEvent(new Event('c0look-scenery'));
    },
  },
});

// The saved value, once the settings are loaded (no static import: this file loads while settings.ts is being built).
let loaded: { truePx: boolean } | undefined;
void import('../settings').then((s) => (loaded = s.settings));
